export const fetcher = (url, args?): Promise<any> => {
  const addToken = args?.token
    ? { Authorization: `Bearer ${args?.token}` }
    : args;

  return fetch(url, {
    method: 'GET',
    ...args,
    headers: {
      ...addToken,
      ...(args?.unsetContentType
        ? {}
        : args?.contentType
        ? args?.contentType
        : { 'Content-Type': 'application/json' }),
    },
  }).then(async (res) => {
    if (!res.ok) {
      const errorData = await res.json().catch(() => null);
      const errorMessage = `${res.status} (${res.statusText}) | ${args?.method || 'GET'} ${url}` +
        (errorData?.message ? ` --- ${errorData.message}` : '');
      throw Object.assign(new Error(errorMessage), { data: errorData });
    }
    switch (args?.returnType) {
      case 'TEXT':
        return res.text().catch(() => res);
      case 'JSON':
        return res.json().catch(() => res);
      case 'RAW':
        return res;
      default:
        return res.json().catch(() => res);
    }
  });
};